@import '../../styles/host.css';

:host {
    display: block;
}

.tab-pane {
    padding: 1rem;
}
